import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFetch, CreateAsyncStatusHandler } from "../../app/SliceUtils";

export const fetchFavorites = createAsyncThunk(
    '/api/favorite/user',
    (departmentId, { rejectWithValue }) =>
        ApiFetch({
            endpoint: departmentId ?
                `api/favorite/user/${departmentId}` :
                `api/favorite/user`,
            contentType: 'application/x-www-form-urlencoded'
        }, rejectWithValue)
);

export const fetchFavoriteSettings = createAsyncThunk(
    '/api/favorite/userSettings',
    (departmentId, { rejectWithValue }) =>
        ApiFetch({
            endpoint: departmentId ?
                `api/favorite/userSettings/${departmentId}` :
                `api/favorite/userSettings`,
            contentType: 'application/x-www-form-urlencoded'
        }, rejectWithValue)
);

export const addFavorite = createAsyncThunk(
    '/api/favorite/post',
    ({ activityId, departmentId }, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/favorite`,
            method: 'POST',
            body: {
                activityId: activityId,
                departmentId: departmentId,
            }
        }, rejectWithValue)
);

export const removeFavorite = createAsyncThunk(
    '/api/favorite/delete',
    ({ activityId, departmentId }, { rejectWithValue }) =>
        ApiFetch({ 
            endpoint: `api/favorite`,
            method: 'DELETE',
            body: {
                activityId: activityId,
                departmentId: departmentId,
            }
        }, rejectWithValue)
);

export const favoritesSlice = createSlice({
    name: "favorites",
    initialState: {
        favorites: { data: null, status: null },
        favoriteSettings: { data: null, status: null },
        favoriteAdd: { data: null, status: null },
        favoriteRemove: { data: null, status: null },
    },
    reducers: {},
    extraReducers: (builder) => {
        CreateAsyncStatusHandler(builder, fetchFavorites, 'favorites');
        CreateAsyncStatusHandler(builder, fetchFavoriteSettings, 'favoriteSettings');
        CreateAsyncStatusHandler(builder, addFavorite, 'favoriteAdd');
        CreateAsyncStatusHandler(builder, removeFavorite, 'favoriteRemove');
    },
});

export default favoritesSlice.reducer;
